import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

//components
import FormDatePicker from "./components/FormDatePicker.vue";
Vue.component("form-date-picker", FormDatePicker);
//end components

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
